module.exports = __webpack_public_path__ + "assets/img/Edito_Nicolas-Feit_cover.0e511973-ps.jpg";